export default {"src":"/_next/static/image/public/images/headphone.f461012282f4341d4309e6ed55bc51ed.svg","height":135,"width":120};